var $ = require('jquery');

'use strict';

var PLUGIN_NAME = 'passwordToggle';

var DEFAULTS = {
};

// The actual plugin constructor
function PasswordToggle(element, options) {
	this.element = element;

	this.options = $.extend(true, {}, DEFAULTS, options);

	this._defaults = DEFAULTS;
	this._name = PLUGIN_NAME;
	this.$me = $(this.element);

	this.initialise();
}

/**
 * init
 */
PasswordToggle.prototype.initialise = function() {
	var self = this;

	self.buildHtml();
	self.bindEvents();
};

PasswordToggle.prototype.buildHtml = function() {
	var self = this;

	self.$me.wrap('<div class="password-toggle form-control-password-toggle-wrapper"></div>');
	self.$icoHandler = $('<span class="password-toggle__ico ico-handler"><svg class="svg-icon"><use xlink:href="/build/img/svg/svg-sprite.svg#password-toggle"></use></svg><svg class="svg-icon svg-icon--active"><use xlink:href="/build/img/svg/svg-sprite.svg#password-toggle-active"></use></svg></span>');
	self.$icoHandler.insertAfter(self.$me);
};


PasswordToggle.prototype.bindEvents = function() {
	var self = this,
		$this = self.$me,
		currentType;

	self.$icoHandler.on('click', function(){
		$this.toggleClass('visible');
		currentType = $this.attr('type');

		if (currentType == 'text') {
			$this.attr('type','password');
		}
		else {
			$this.attr('type','text');
		}
	});

  self.handleVisibility($this);

	$this.on('input', function() {
    self.handleVisibility($this);
  });

};

PasswordToggle.prototype.handleVisibility = function($element) {
  var self = this;

  if ($element.val() == '') {
    self.$icoHandler.addClass('hidden');
  }
  else {
    self.$icoHandler.removeClass('hidden');
  }
}



/**
 * decide, which methods will be "public"
 */
var API = {
	//action: PasswordToggle.prototype.action
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *         if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function(value) {
	var args = arguments;

	return this.each(function() {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new PasswordToggle(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/plugins/jquery.password-toggle.js